<template>
    <b-alert
        :show="show"
        :variant="variant === 'help' ? 'info' : variant"
        :dismissible="dismissible"
    >
        <slot name="override">
            <FontAwesomeIcon
                v-if="!expandedAlert"
                class="alert-icon"
                :icon="['fas', icon]"
            />

            <div class="alert-content">
                <h4 :class="[{'strong-text': expandedAlert}]">
                    <slot />
                </h4>
                <p
                    v-if="expandedAlert"
                    class="expanded-text"
                >
                    <slot name="expandedText" />
                </p>
            </div>
        </slot>
    </b-alert>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {
        faCheckCircle,
        faExclamationTriangle,
        faInfoCircle,
        faQuestionCircle,
        faTimesCircle,
    } from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(
        faCheckCircle,
        faExclamationTriangle,
        faInfoCircle,
        faQuestionCircle,
        faTimesCircle,
    );

    /**
     * @group Feedback
     * A component to utilize a Kit Car Alert.
     */
    export default {
        name: 'Alert',
        components: {
            FontAwesomeIcon,
        },
        props: {

            /**
             * Applies one of the Kit Car theme color variants to the component.
             */
            variant: {
                // `'success'` / `'help'` / `'info'` / `'warning'` / `'error'`
                type: String,
                required: false,
                // `'success'`
                default: 'success',
                validator(value) {
                    return ['success', 'help', 'info', 'warning', 'error'].includes(value);
                },
            },
            /**
             * When set, shows the alert. Set to a number (seconds) to show and automatically dismiss the alert after the number of seconds has elapsed.
             */
            show: {
                type: Boolean,
                required: false,
                // `true`
                default: true,
            },
            /**
             * When set, enables the dismiss close button.
             */
            dismissible: {
                type: Boolean,
                required: false,
                // `true`
                default: true,
            },
        },
        data() {
            return {
                expandedAlert: false,
            };
        },
        computed: {
            icon() {
                return {
                    success: 'check-circle',
                    info: 'info-circle',
                    help: 'question-circle',
                    warning: 'exclamation-triangle',
                    error: 'times-circle'
                }[this.variant];
            }
        },
        mounted() {
            this.checkForExpandedSlot();
        },
        methods: {
            checkForExpandedSlot() {
                this.expandedAlert = this.$slots.expandedText && this.$slots.expandedText[0];
            }
        }
    };
</script>
